<template>
  <div class="gameBox">
    <div class="bg1"></div>
    <div class="bg2" v-show="lampShow"></div>
    <div class="start" @click="move">
      <p>【可抽{{number_of_draws}}次】</p>
    </div>
    <ul>
      <li v-for="(item,i) in list" :key="i" :class="['item' + (i+1), {'active': index == i}]">
        <div class="img1">
          <img :src="item.image" alt="">
        </div>
        <p>{{item.prize_name}}</p>
      </li>
    </ul>
    <van-dialog v-model="show" title="注册成功后参与抽奖" show-cancel-button>
      <van-field v-model="phone" placeholder="请输入手机号"/>
      <van-field v-model="sms" center clearable placeholder="请输入验证码">
        <template #button>
          <van-button size="small" type="primary">获取验证码</van-button>
        </template>
      </van-field>
    </van-dialog>
    <div class="vanstyle">
      <van-dialog v-model="show1">
        <div class="prize-box">
          <div class="prize-back">
            <img src="../assets/activitiesimg/prize.svg" alt="">
          </div>
          <div class="currency">
            <img :src="image" alt="">
          </div>
          <div class="currency-text">
            <strong>{{prize_name}}</strong>
            <P>奖励请在【我的奖品】中查看</P>
          </div>
          <div class="more" @click="prizeClose">
            <img src="../assets/activitiesimg/more.svg" alt="">
          </div>
        </div>
        <div class="close" @click="prizeClose">
          <img src="../assets/activitiesimg/close.svg" alt="">
        </div>
      </van-dialog>
      <van-dialog v-model="show2">
        <div class="prize-box">
          <div class="prize-back">
            <img src="../assets/activitiesimg/thank.png" alt="">
          </div>
          <div class="currency">
            <img src="../assets/activitiesimg/smiled.svg" alt="">
          </div>
          <div class="currency-text">
            <strong>谢谢参与</strong>
            <P>哎呀 这次手气不佳～</P>
          </div>
          <div class="more" @click="prizeClose1">
            <img src="../assets/activitiesimg/more.svg" alt="">
          </div>
        </div>
        <div class="close" @click="prizeClose1">
          <img src="../assets/activitiesimg/close.svg" alt="">
        </div>
      </van-dialog>
    </div>
</div>
</template>

<script>
  export default {
    name: 'luckDraw',
    props:{
      luckyNum: Number,
      awardsNum: Number,
    },
    data() {
      return {
        show: false,
        show1: false,
        show2: false,
        token: null,
        sms: '',
        phone: '',
        list: [
          {id:1,image:require('../assets/activitiesimg/currency.png'),prize_name:'10元抵用卷'},
          {id:2,image:require('../assets/activitiesimg/card1.png'),prize_name:'非瘟抗体抵用券'},
          {id:3,image:require('../assets/activitiesimg/currency.png'),prize_name:'20元抵用券'},
          {id:4,image:require('../assets/activitiesimg/Pets.png'),prize_name:'猫粮/狗粮一份'},
          {id:5,image:require('../assets/activitiesimg/face.png'),prize_name:'谢谢参与'},
          {id:6,image:require('../assets/activitiesimg/iphone.png'),prize_name:'iPhone12'},
          {id:7,image:require('../assets/activitiesimg/jd.png'),prize_name:'50元京东卡'},
          {id:8,image:require('../assets/activitiesimg/card2.png'),prize_name:'咨询专家抵用券'},
        ],//奖品列表
        image: '',
        prize_name: '',
        index: 0, // 当前转动到哪个位置，第一次起点位置0,对应页面item1位置
        count: 8, // 总共有多少个位置
        times: 0, // 转动跑格子次数,
        cycle: 60, // 转动基本次数：即至少需要转动多少次再进入抽奖环节
        speed: 200, // 初始转动速度
        lampShow:false,//开始抽奖，灯光闪烁
        timer: 0, // 转动定时器
        lamp:0, // 灯光定时器
        prize: 0, // 中奖位置，接口返回
        number_of_draws:0,//限制每天抽奖次数，接口返回
        prize_data: {//中奖信息
          id:Number,//奖品ID
          name:'',//奖品名称
          number:Number,//奖品数量
          image:'',//奖品图片
          type:Number,// 奖品类型
        },
      }
    },
    mounted() {
      this.number_of_draws = this.luckyNum
      //获取奖品列表
      // this.axios.post('/api/luckdraw/prizeList').then(res=>{
      //   if(res.status == 1){
      //     this.list = res.data.list; // 奖品列表数据
      //     this.number_of_draws = res.data.number_of_draws; // 该用户剩余抽奖次数
      //   }
      // })
    },
    methods: {
      prizeClose() {
        this.show1 = false
      },
      prizeClose1() {
        this.show2 = false
      },
      currentRow(row){
        this.$emit('currentRow',row)
      },
      //点击开始抽奖
      move() {
        // console.log('ddddddddd')
        if (this.token == null) {
          this.show = true
        } else {
          if( this.number_of_draws == 0){
            this.$toast('抽奖次数已用完，请明天再来哦');
          }else if(this.times != 0){
            this.$toast('正在抽奖中，请勿重复点击')
          } else{
            // this.axios.post(baseURL+'/api/luckdraw/doDraw').then(res=>{
            //   if(res.status == 1){
            this.number_of_draws--;//抽奖开始，次数-1
            this.speed = 200;//每次抽奖速度初始化为200
            // this.awardsNum = 4;//已经拿到中奖信息，页面展示，等抽奖结束后，将弹窗弹出
            this.prize = this.awardsNum - 1;//中奖位置赋值，跑马灯最终停留位置，这里实际位置需要-1
            this.startRoll();//执行抽奖
            this.lamp = setInterval(()=>{//灯光闪烁开启
              this.lampShow = !this.lampShow;
            },500)
            //   }
            // })
          }
        }
      },
      // 开始转动
      startRoll() {
        this.times += 1; // 转动次数
        this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
        this.usePrize();
      },
      
      // 每一次转动
      oneRoll() {
        let index = this.index; // 当前转动到哪个位置
        const count = 8; // 总共有多少个位置
        index += 1;
        if (index > count - 1) {
          index = 0;
        }
        this.index = index;
      },

      usePrize() {
        // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
        if (this.times > this.cycle +10 && this.prize === this.index) {
          clearTimeout(this.timer); // 清除转动定时器
          clearTimeout(this.lamp); // 清除灯光定时器
          this.lampShow = false; // 白色灯隐藏
          this.times = 0; // 转动跑格子次数初始化为0，可以开始下次抽奖
          if (this.awardsNum == 5) {
            this.show2 = true
          } else {
            this.show1 = true
            // console.log('list',this.list)
            this.image = this.list[this.awardsNum-1].image
            this.prize_name = this.list[this.awardsNum-1].prize_name
          }
          // if(this.prize_data.type == 0){
          //   console.log('未中奖，谢谢参与');//未中奖提示弹出，
          // }else{
          //   console.log('中奖啦');//中奖弹出提示
          // }
        } else {
          if(this.times < this.cycle -20){
            this.speed -= 10; // 加快转动速度
          }else{
            this.speed += 10; // 抽奖即将结束，放慢转动速度
          }
          this.timer = setTimeout(this.startRoll, this.speed);//开始转动
        }
      },
    },
  }
</script>

<style lang="scss">
/*
 整体布局采用定位实现
 gameBox:父盒子，最外层背景图
 bg1:灰色灯
 bg2:点击开始按钮后，白色灯出现，同时要每个500s同bg1做切换隐藏显示
 start：按钮样式
 item1-8:通过定位方式将dom元素顺时针排列
 active：点击开始开妞后，从1位置开始高亮，类似跑马灯
*/
.el-dialog, .el-pager li {
  background: none!important;
}
.vanstyle {
  .van-dialog {
    background: none !important;
  }
  .van-dialog .van-button {
    display: none !important;
  }
  .van-dialog__content {
    height: 500px;
  }
  .prize-box {
    position: relative;
    .prize-back {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .currency {
      position: absolute;
      top: 150px;
      width: 100%;
      img {
        width: 100px;
        height: 100px;
      }
    }
    .currency-text {
      position: absolute;
      bottom: 90px;
      width: 100%;
      text-align: center;
      strong {
        font-size: 16px;
        font-weight: bold;
        color: #BC3C00;
      }
      p {
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
        color: #ADADAD;
      }
    }
    .more {
      position: absolute;
      bottom: 20px;
      width: 100%;
      text-align: center;
      img {
        max-width: 100%;
      }
    }
  }
  .close {
    position: absolute;
    bottom: 0px;
    width: 100%;
    img {
      width: 50px;
      height: 50px;
    }
  }
  @media screen and (max-width: 320px) {
    .prize-box {
      position: relative;
      .prize-back {
        width: 100%;
        img {
          width: 100%;
        }
      }
      .currency {
        position: absolute;
        top: 140px;
        width: 100%;
        img {
          width: 90px;
          height: 90px;
        }
      }
      .currency-text {
        position: absolute;
        bottom: 80px;
        width: 100%;
        text-align: center;
        strong {
          font-size: 16px;
          font-weight: bold;
          color: #BC3C00;
        }
        p {
          padding-top: 5px;
          font-size: 14px;
          font-weight: bold;
          color: #ccc;
        }
      }
      .more {
        position: absolute;
        bottom: 15px;
        width: 100%;
        text-align: center;
        img {
          max-width: 100%;
        }
      }
    }
    .close {
      position: absolute;
      bottom: 40px;
      width: 100%;
      img {
        width: 50px;
        height: 50px;
      }
    }
  }
}

.gameBox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 580px;
  height: 580px;
  border-radius: 8px;
  // background: #AE1616;
  // background: url(../../common/images/home/game1.png)no-repeat left top;
  // background-size: 326px 326px;
  position: relative;
  .bg1 {
    position: absolute;
    left: 4.5px;
    top: 4px;
    width: 580px;
    height: 580px;
    // background: url(../../common/images/home/game3.png)no-repeat center;
    // background-size: 317px 317px;
  }
  .bg2 {
    position: absolute;
    left: 4.5px;
    top: 4px;
    width: 580px;
    height: 580px;
    // background: url(../../common/images/home/game2.png)no-repeat center;
    // background-size: 317px 317px;
  }
  .start {
    position: relative;
    width: 180px;
    height: 180px;
    margin: 0;
    background: url(../assets/activitiesimg/button.png)no-repeat center;
    background-size: 180px 180px;
    p {
      position: absolute;
      bottom: 30px;
      width: 100%;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      color:#4A4A4A;
    }
  }
  ul {
    li {
      position: absolute;
      width: 180px;
      height: 180px;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      font-size: 0;
      text-align: center;
      .img1 {
        display: inline-block;
        margin-top: 5px;
        width: 120px;
        height: 120px;
        img {
          width: 100%;
        }
      }
      p {
        margin-top: 15px;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        color:#4A4A4A;
      }
    }
    .item1 {left: 10px;top: 10px;}
    .item2 {left: 202px;top: 10px;}
    .item3 {left: 395px;top: 10px;}
    .item4 {left: 395px;top: 200px;}
    .item5 {left: 395px;top: 390px;}
    .item6 {left: 202px;top: 390px;}
    .item7 {left: 10px;top: 390px;}
    .item8 {left: 10px;top: 200px;}
    .active {background: #FFF2B1;}
  }
}

@media screen and (max-width: 780px) {
  .gameBox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 410px;
    height: 410px;
    border-radius: 8px;
    // background: #AE1616;
    // background: url(../../common/images/home/game1.png)no-repeat left top;
    // background-size: 326px 326px;
    position: relative;
    .bg1 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 410px;
      height: 410px;
      // background: url(../../common/images/home/game3.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .bg2 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 410px;
      height: 410px;
      // background: url(../../common/images/home/game2.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .start {
      position: relative;
      width: 180px;
      height: 180px;
      margin: 170px 0 0 170px;
      background: url(../assets/activitiesimg/button.png)no-repeat center;
      background-size: 180px 180px;
      p {
        position: absolute;
        bottom: 30px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color:#4A4A4A;
      }
    }
    ul {
      li {
        position: absolute;
        width: 180px;
        height: 180px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        font-size: 0;
        text-align: center;
        .img1 {
          display: inline-block;
          margin-top: 5px;
          width: 120px;
          height: 120px;
          img {
            width: 100%;
          }
        }
        p {
          margin-top: 15px;
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          color:#4A4A4A;
        }
      }
      .item1 {left: 10px;top: 10px;}
      .item2 {left: 202px;top: 10px;}
      .item3 {left: 395px;top: 10px;}
      .item4 {left: 395px;top: 200px;}
      .item5 {left: 395px;top: 390px;}
      .item6 {left: 202px;top: 390px;}
      .item7 {left: 10px;top: 390px;}
      .item8 {left: 10px;top: 200px;}
      .active {background: #FFF2B1;}
    }
  }
}

@media screen and (max-width: 430px) {
  .gameBox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 325px;
    height: 325px;
    border-radius: 8px;
    // background: #AE1616;
    // background: url(../../common/images/home/game1.png)no-repeat left top;
    // background-size: 326px 326px;
    position: relative;
    .bg1 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 325px;
      height: 325px;
      // background: url(../../common/images/home/game3.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .bg2 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 325px;
      height: 325px;
      // background: url(../../common/images/home/game2.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .start {
      position: relative;
      width: 100px;
      height: 100px;
      margin: 5px 0 0 2px;
      background: url(../assets/activitiesimg/button.png)no-repeat center;
      background-size: 100px 100px;
      p {
        position: absolute;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color:#4A4A4A;
      }
    }
    ul {
      li {
        position: absolute;
        width: 100px;
        height: 100px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        font-size: 0;
        text-align: center;
        .img1 {
          display: inline-block;
          margin-top: 5px;
          width: 70px;
          height: 70px;
          img {
            width: 100%;
          }
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          font-weight: bold;
          text-align: center;
          color:#4A4A4A;
        }
      }
      .item1 {left: 8px;top: 8px;}
      .item2 {left: 114px;top: 8px;}
      .item3 {left: 220px;top: 8px;}
      .item4 {left: 220px;top: 114px;}
      .item5 {left: 220px;top: 220px;}
      .item6 {left: 114px;top: 220px;}
      .item7 {left: 8px;top: 220px;}
      .item8 {left: 8px;top: 114px;}
      .active {background: #FFF2B1;}
    }
  }
}

@media screen and (max-width: 420px) {
  .gameBox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 310px;
    height: 310px;
    border-radius: 8px;
    // background: #AE1616;
    // background: url(../../common/images/home/game1.png)no-repeat left top;
    // background-size: 326px 326px;
    position: relative;
    .bg1 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 310px;
      height: 310px;
      // background: url(../../common/images/home/game3.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .bg2 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 310px;
      height: 310px;
      // background: url(../../common/images/home/game2.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .start {
      position: relative;
      width: 90px;
      height: 90px;
      margin: 0;
      background: url(../assets/activitiesimg/button.png)no-repeat center;
      background-size: 90px 90px;
      p {
        position: absolute;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color:#4A4A4A;
      }
    }
    ul {
      li {
        position: absolute;
        width: 90px;
        height: 90px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        font-size: 0;
        text-align: center;
        .img1 {
          display: inline-block;
          margin-top: 5px;
          width: 55px;
          height: 55px;
          img {
            width: 100%;
          }
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          font-weight: bold;
          text-align: center;
          color:#4A4A4A;
        }
      }
      .item1 {left: 10px;top: 10px;}
      .item2 {left: 110px;top: 10px;}
      .item3 {left: 210px;top: 10px;}
      .item4 {left: 210px;top: 110px;}
      .item5 {left: 210px;top: 210px;}
      .item6 {left: 110px;top: 210px;}
      .item7 {left: 10px;top: 210px;}
      .item8 {left: 10px;top: 110px;}
      .active {background: #FFF2B1;}
    }
  }
}

@media screen and (max-width: 390px) {
  .gameBox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 290px;
    height: 290px;
    border-radius: 8px;
    // background: #AE1616;
    // background: url(../../common/images/home/game1.png)no-repeat left top;
    // background-size: 326px 326px;
    position: relative;
    .bg1 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 290px;
      height: 290px;
      // background: url(../../common/images/home/game3.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .bg2 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 290px;
      height: 290px;
      // background: url(../../common/images/home/game2.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .start {
      position: relative;
      width: 85px;
      height: 85px;
      margin: 5px 0 0 6px;
      background: url(../assets/activitiesimg/button.png)no-repeat center;
      background-size: 85px 85px;
      p {
        position: absolute;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color:#4A4A4A;
      }
    }
    ul {
      li {
        position: absolute;
        width: 85px;
        height: 85px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        font-size: 0;
        text-align: center;
        .img1 {
          display: inline-block;
          margin-top: 5px;
          width: 55px;
          height: 55px;
          img {
            width: 100%;
          }
        }
        p {
          margin-top: 5px;
          font-size: 10px;
          font-weight: bold;
          text-align: center;
          color:#4A4A4A;
        }
      }
      .item1 {left: 10px;top: 10px;}
      .item2 {left: 106px;top: 10px;}
      .item3 {left: 203px;top: 10px;}
      .item4 {left: 203px;top: 105px;}
      .item5 {left: 203px;top: 200px;}
      .item6 {left: 106px;top: 200px;}
      .item7 {left: 10px;top: 200px;}
      .item8 {left: 10px;top: 105px;}
      .active {background: #FFF2B1;}
    }
  }
}

@media screen and (max-width: 380px) {
  .gameBox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 280px;
    height: 280px;
    border-radius: 8px;
    // background: #AE1616;
    // background: url(../../common/images/home/game1.png)no-repeat left top;
    // background-size: 326px 326px;
    position: relative;
    .bg1 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 280px;
      height: 280px;
      // background: url(../../common/images/home/game3.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .bg2 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 280px;
      height: 280px;
      // background: url(../../common/images/home/game2.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .start {
      position: relative;
      width: 80px;
      height: 80px;
      margin: 0;
      background: url(../assets/activitiesimg/button.png)no-repeat center;
      background-size: 80px 80px;
      p {
        position: absolute;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color:#4A4A4A;
      }
    }
    ul {
      li {
        position: absolute;
        width: 80px;
        height: 80px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        font-size: 0;
        text-align: center;
        .img1 {
          display: inline-block;
          margin-top: 5px;
          width: 55px;
          height: 55px;
          img {
            width: 100%;
          }
        }
        p {
          margin-top: 5px;
          font-size: 10px;
          font-weight: bold;
          text-align: center;
          color:#4A4A4A;
        }
      }
      .item1 {left: 8px;top: 10px;}
      .item2 {left: 100px;top: 10px;}
      .item3 {left: 194px;top: 10px;}
      .item4 {left: 194px;top: 100px;}
      .item5 {left: 194px;top: 190px;}
      .item6 {left: 100px;top: 190px;}
      .item7 {left: 8px;top: 190px;}
      .item8 {left: 8px;top: 100px;}
      .active {background: #FFF2B1;}
    }
  }
}

@media screen and (max-width: 360px) {
  .gameBox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 275px;
    height: 275px;
    border-radius: 8px;
    // background: #AE1616;
    // background: url(../../common/images/home/game1.png)no-repeat left top;
    // background-size: 326px 326px;
    position: relative;
    .bg1 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 275px;
      height: 275px;
      // background: url(../../common/images/home/game3.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .bg2 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 275px;
      height: 275px;
      // background: url(../../common/images/home/game2.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .start {
      position: relative;
      width: 80px;
      height: 80px;
      margin: 0;
      background: url(../assets/activitiesimg/button.png)no-repeat center;
      background-size: 80px 80px;
      p {
        position: absolute;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color:#4A4A4A;
      }
    }
    ul {
      li {
        position: absolute;
        width: 80px;
        height: 80px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        font-size: 0;
        text-align: center;
        .img1 {
          display: inline-block;
          margin-top: 5px;
          width: 55px;
          height: 55px;
          img {
            width: 100%;
          }
        }
        p {
          margin-top: 5px;
          font-size: 10px;
          font-weight: bold;
          text-align: center;
          color:#4A4A4A;
        }
      }
      .item1 {left: 8px;top: 10px;}
      .item2 {left: 98px;top: 10px;}
      .item3 {left: 186px;top: 10px;}
      .item4 {left: 186px;top: 98px;}
      .item5 {left: 186px;top: 186px;}
      .item6 {left: 97px;top: 186px;}
      .item7 {left: 8px;top: 186px;}
      .item8 {left: 8px;top: 98px;}
      .active {background: #FFF2B1;}
    }
  }
}

@media screen and (max-width: 320px) {
  .gameBox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 240px;
    height: 240px;
    border-radius: 8px;
    // background: #AE1616;
    // background: url(../../common/images/home/game1.png)no-repeat left top;
    // background-size: 326px 326px;
    position: relative;
    .bg1 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 240px;
      height: 240px;
      // background: url(../../common/images/home/game3.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .bg2 {
      position: absolute;
      left: 4.5px;
      top: 4px;
      width: 240px;
      height: 240px;
      // background: url(../../common/images/home/game2.png)no-repeat center;
      // background-size: 317px 317px;
    }
    .start {
      position: relative;
      width: 70px;
      height: 70px;
      margin: 0;
      background: url(../assets/activitiesimg/button.png)no-repeat center;
      background-size: 70px 70px;
      p {
        position: absolute;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 10px;
        font-weight: bold;
        color:#4A4A4A;
      }
    }
    ul {
      li {
        position: absolute;
        width: 70px;
        height: 70px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        font-size: 0;
        text-align: center;
        .img1 {
          display: inline-block;
          margin-top: 5px;
          width: 45px;
          height: 45px;
          img {
            width: 100%;
          }
        }
        p {
          margin-top: 5px;
          font-size: 10px;
          font-weight: bold;
          text-align: center;
          color:#4A4A4A;
        }
      }
      .item1 {left: 8px;top: 6px;}
      .item2 {left: 86px;top: 6px;}
      .item3 {left: 164px;top: 6px;}
      .item4 {left: 164px;top: 85px;}
      .item5 {left: 164px;top: 165px;}
      .item6 {left: 86px;top: 165px;}
      .item7 {left: 8px;top: 165px;}
      .item8 {left: 8px;top: 85px;}
      .active {background: #FFF2B1;}
    }
  }
}
</style>